import { Icon } from "@legal-500/legal500-design-system";
import styles from "./LoadingState.module.css";

type LoadingStateProps = {
  fullscreen?: boolean;
  message?: string;
};

export default function LoadingState({
  fullscreen = false,
  message = "Loading...",
}: LoadingStateProps) {
  if (fullscreen) {
    return (
      <div className={styles.fullscreen} role="status" aria-live="polite" aria-label={message}>
        <div className={styles.bootSpinner} aria-hidden="true"></div>
        <span className={styles.srOnly}>{message}</span>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Icon icon="settings-cog" size="xlarge" className={styles.icon} />
      <p className={styles.text}>{message}</p>
    </div>
  );
}
